import React from 'react'

export default (props) => (
    <img src="/CoinLogo.png" alt="Logo" {...props} />
)